export default __webpack_public_path__ + "static/media/fintech-guild-badge.cb55d442.png";